module.exports = __webpack_public_path__ + "img/d4162ed503e18ac0acae656163fde7a6.6ab04efd.png";